import React from "react";
import { toast } from "react-toastify";
import { Link, Redirect } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import RV from "simple-react-validator";
import InputMask from "react-input-mask";
import * as CONFIG from "./_config";
import ls from "local-storage";
toast.configure();
const axios = require("axios");

const Loader = () => <div className="loading-emp"></div>;

class Employment extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      date: new Date(),
      formControls: {},
      stores: [],
      loading: false,
      storesGroups: null,
    };
  }
  onChange = (date) => this.setState({ date });

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      this.Stores();
      this.Login();
    }
  }

  componentDidMount() {
    this.Stores();
    ls.set("redirectTo", window.location.href);

    if (
      CONFIG.DATA.RSA_SUBDOMAIN === "dicksfreshmarket" ||
      CONFIG.DATA.RSA_SUBDOMAIN === "leechlakemarket" ||
      CONFIG.DATA.RSA_SUBDOMAIN === "grocerydepotms" ||
      CONFIG.DATA.RSA_SUBDOMAIN === "okpricemart"
    ) {
      //return <Redirect to='/login'/>

      this.props.history.push("/error");
    }
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  handleChange = (value) => {
    // console.log("Captcha value:", value);
    this.setState({
      formControls: { ...this.state.formControls, ["Captcha"]: value },
    });
  };

  showLoader = () => {
    this.setState({ loading: true });
  };

  hideLoader = () => {
    this.setState({ loading: false });
  };

  asyncScriptOnLoad = () => {
    // this.setState({ callback: "called!" });
    // console.log("scriptLoad - reCaptcha Ref-", this._reCaptchaRef);
  };

  Employment = async (e) => {
    e.preventDefault();

    this.showLoader();

    const datails = this.state.formControls;
    var body =
      '<table  border="1px" style="border-collapse: collapse;width: 100%; text-align:left;border:1px solid #000" cellpadding="3" cellspacing="0"> &&& </table>';
    // var body = '<table style="border-collapse: collapse;width: 100%; text-align:left"> &&& </table>';
    var tr = "";

    if (!this.validator.allValid()) {
      this.validator.showMessages();

      // console.log('this.validator',this.validator);
      this.forceUpdate();
      this.hideLoader();

      return false;
    }

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Name</td><td style='color:#333;border-bottom:0px;' width="33%">Phone</td><td style='color:#333;border-bottom:0px;' width="33%">Email</td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["name"]}</td><td style='border-top:0px'>${datails["phone"]}</td><td style='border-top:0px'>${datails["email"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' colspan='3'>Street Address</td></tr>`;
    tr += `<tr><td style='border-top:0px' colspan='3'>${datails["street_address"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">City</td><td style='color:#333;border-bottom:0px;' width="33%">State / Province / Region</td><td style='color:#333;border-bottom:0px;' width="33%">Code / Country</td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["city"]}</td><td style='border-top:0px'>${datails["state"]}</td><td style='border-top:0px'>${datails["zip_code"]} / ${datails["country"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">How long have you lived at this address?*</td><td style='color:#333;border-bottom:0px;' width="33%">Referred By</td>`;
    if (
      CONFIG.DATA.BACKEND_HOST == "diamondfood" ||
      CONFIG.DATA.BACKEND_HOST == "cashsaverstore" ||
      CONFIG.DATA.BACKEND_HOST == "metrodiscount"
    ) {
      tr += `<td style='color:#333;border-bottom:0px;' width="33%">Position Applying For / Date you can start</td></tr>`;
    } else {
      tr += `<td style='color:#333;border-bottom:0px;' width="33%"> Date you can start</td></tr>`;
    }
    tr += `<tr><td style='border-top:0px'>${datails["how_long_have_you_lived_at_this_address"]}</td><td style='border-top:0px'>${datails["referred_by"]}</td>
    
    <td style='border-top:0px'> ${datails["date_you_can_start"]}</td></tr>`;

    // tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Age${
    //   CONFIG.DATA.ALLOW_EMPLOYMENT_PAGE_AGE_FILED_OPTION ? "" : "*"
    // } </td></tr>`;
    // tr += `<tr><td style='border-top:0px'>${datails["age"]}</td></tr>`;

    tr += `<tr><td style='border-left:0px;border-right:0px' colspan="3"><div style="height:50px;"></div></td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' colspan='3' width="100%">Do you now or have you ever had a relative (includes in-laws) that worked for ${CONFIG.DATA.RSA_CLIENT_APP_NAME} ? (Yes or No)<br/> If yes, please list their name(s) and location(s)</td></tr>`;
    tr += `<tr><td style='border-top:0px' colspan='3'>${datails["do_you_now_or_have_you_ever_had_a_relative_includes_in_laws_that_worked_for_us"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Are you currently in High School (Yes or No)*</td><td style='color:#333;border-bottom:0px;' width="33%">College or University Credits (Yes or No) *    </td><td style='color:#333;border-bottom:0px;' width="33%">Did you earn a degree(s)? (Yes or No) *    </td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["are_you_currently_in_high_school"]}</td><td style='border-top:0px'>${datails["college_or_university_credits"]}</td><td style='border-top:0px'>${datails["did_you_earn_a_degree"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Company Name *    </td><td style='color:#333;border-bottom:0px;' width="33%">Phone Number *    </td><td style='color:#333;border-bottom:0px;' width="33%">Street Address * </td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["company_name1"]}</td><td style='border-top:0px'>${datails["phone_number1"]}</td><td style='border-top:0px'>${datails["street_address1"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">City</td><td style='color:#333;border-bottom:0px;' width="33%">State / Province / Region</td><td style='color:#333;border-bottom:0px;' width="33%">Code / Country</td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["city2"]}</td><td style='border-top:0px'>${datails["state2"]}</td><td style='border-top:0px'>${datails["postal"]} / ${datails["country2"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Start Date*    </td><td style='color:#333;border-bottom:0px;' width="33%">End Date*    </td>
     </tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["start_date"]}</td><td style='border-top:0px'>${datails["end_date"]}</td>
   </tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Reason for Leaving</td><td style='color:#333;border-bottom:0px;' colspan='2' width="66%">Please indicate the job duties you have performed which relate to the position for which you are applying* </td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["reason_for_leaving"]}</td><td style='border-top:0px' valign="top" rowspan="3" colspan='2'>${datails["the_job_duties"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;'>How many jobs have you had in the last 5 years not listed above </td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["how_many_jobs_have_you_had_in_the_last_5_years_not_listed_above"]}</td></tr>`;

    tr += `<tr><td style='border-left:0px;border-right:0px' colspan="3"><div style="height:50px;"></div></td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Are you eligible for employment in the United States? (Yes or No) *</td><td style='color:#333;border-bottom:0px;' colspan='2' width="66%">Additional Notes</td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["are_you_eligible_for_employment_in_the_united_states"]}</td><td style='border-top:0px' valign="top" rowspan="5" colspan='2'>${datails["additional_notes"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Days Available for Work*(Mon,Tue,Wed,Thu,Fri,Sat,Sun)</td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["days_available_for_work"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Hours Available for Work</td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["hours_available_for_work"]}</td></tr>`;

    tr += `<tr><td style='color:#333;border-bottom:0px;' width="33%">Name</td><td style='color:#333;border-bottom:0px;' width="33%">Store Location</td><td style='color:#333;border-bottom:0px;' width="33%">Date</td></tr>`;
    tr += `<tr><td style='border-top:0px'>${datails["name1"]}</td><td style='border-top:0px'>${datails["store_location"]}</td><td style='border-top:0px'>${datails["date2"]}</td></tr>`;

    // var count = 0;
    // for (let [key, value] of Object.entries(datails)) {

    //   // console.log(count++, key, document.getElementsByName(key)[0].parentNode.textContent);

    //   if(key !=='Captcha') {
    //     tr+= '<tr><td>'+key.replace(/_/g," ")+' : </td><td>'+value+'</td></tr>'
    //     /*
    //     // DO NOT USE THIS FOR NOW, DUE TO BODY LIMITATION NOT ALL TEXT ARE SENT TO SERVER.
    //     tr+= '<tr><td style="padding: 3px; width:50%;  text-align: left;  border-bottom: 1px solid #eee;">'
    //       + document.getElementsByName(key)[0].parentNode.textContent.replace('*',"").trim()
    //       + '</td><td style="padding: 3px; width:50%; text-align: left;  border-bottom: 1px solid #eee;">'
    //       + value
    //       + '</td></tr>'
    //     */
    //   }
    // }

    body = body.replace("&&&", tr);

    //console.log(body);    return;

    const data = new FormData();
    data.append("method", "POST");

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/SendEmail`;

    if (this.props && this.props.location.search === "?debug=1") {
      data.append("EmailId", "keyur@rsaamerica.com");
    } else {
      data.append("EmailId", CONFIG.DATA.EMPLOYMENT_EMAIL); //CONFIG.DATA.EMPLOYMENT_EMAIL
    }

    if (
      CONFIG.DATA.BACKEND_HOST == "diamondfood" ||
      CONFIG.DATA.BACKEND_HOST == "cashsaverstore" ||
      CONFIG.DATA.BACKEND_HOST == "metrodiscount"
    ) {
      data.append("EmailSubject", "Enquiry for Employment diamond");
    } else {
      data.append("EmailSubject", "Enquiry for Employment");
    }

    data.append("EmailBody", body);
    data.append("RSAClientId", "XXX");
    data.append("EnterpriseId", "CE6693D83B834CEAB4FA533E604EE58B");
    data.append("SecurityKey", "7C9EF435200042FD953733EBF85B1A3D");
    data.append("CCList", "");
    data.append("BccList", "");

    if (CONFIG.DATA.FROM_EMAIL_ID) {
      data.append("FromEmailId", CONFIG.DATA.FROM_EMAIL_ID);
    } else {
      data.append("FromEmailId", "clientsupport@rsagroceryapp.com");
    }
    data.append("FromName", CONFIG.DATA.RSA_CLIENT_APP_NAME);

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.ErrorMessage.ErrorCode === 1) {
          window.scrollTo(0, 0);
          // window.grecaptcha.reset();
          this.hideLoader();

          toast.success("An email has been sent!");
          document.getElementById("empForm").reset();
        }
      })
      .catch(function (response) {
        console.log(response);
      });
  };

  Stores() {
    var ClientStores = ls.get("ClientStores");
    // console.log("storage", ClientStores);

    /*
      HR:2021-05-20
      Buche foods asked to add static locations only on the "Location" page 
      which shouldn to appear on website or any other place. 
      so we made separate API for fetching stores 
    */

    let IsBucheFoods = CONFIG.DATA.BACKEND_HOST == "buchefoods";
    var apiurl;
    let reqheaders = {};

    if (false && !IsBucheFoods && ClientStores) {
      this.setState({ stores: ClientStores });
    } else {
      const data = new FormData();
      data.append("method", "POST");

      if (IsBucheFoods) {
        // data.append(
        //   "apiurl",
        //   `https://clientsupport.rsaamerica.com/Services/SSWebRestApi.svc/GetStaticClientStores`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetStaticClientStores`;
        reqheaders = { domainname: "clientsupport" };

        data.append("ClientDbName", CONFIG.DATA.RSA_CLIENT_DB_NAME);
        data.append("ClientId", CONFIG.DATA.RSA_CLIENT_ID);
        data.append("ClientStoreId", 0);
        data.append("Token", "");
      } else if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
        // data.append(
        //   "apiurl",
        //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
        reqheaders = { domainname: CONFIG.DATA.RSA_SUBDOMAIN };
      } else {
        // data.append(
        //   "apiurl",
        //   `https://${CONFIG.DATA.RSA_SUBDOMAIN}.rsaamerica.com/Services/SSWebRestApi.svc/GetClientStores/1`
        // );
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
        reqheaders = { domainname: CONFIG.DATA.RSA_SUBDOMAIN };
      }
      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: reqheaders,
        })

        .then((res) => {
          // console.log('res',res);
          ls.set("ClientStores", res.data.GetClientStores);

          var hasSectionName = false;
          if (
            res.data.GetClientStores &&
            res.data.GetClientStores != null &&
            res.data.GetClientStores.length > 0
          ) {
            hasSectionName =
              res.data.GetClientStores[0].SectionName != null &&
              res.data.GetClientStores[0].SectionName.length > 0;
          }
          if (hasSectionName) {
            // console.log("hasSectionName")
            const groupByKey = (list, key) =>
              list.reduce(
                (hash, obj) => ({
                  ...hash,
                  [obj[key]]: (hash[obj[key]] || []).concat(obj),
                }),
                {}
              );
            let storesGroupsList = groupByKey(
              res.data.GetClientStores,
              "SectionName"
            );
            // console.log('storesGroupsList', storesGroupsList);
            this.setState({
              stores: res.data.GetClientStores,
              storesGroups: storesGroupsList,
            });
          } else {
            this.setState({ stores: res.data.GetClientStores });
          }
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }

  render() {
    // var index = this.state.stores;
    //const uniqueStores =  index.filter( (ele, ind) => ind === index.findIndex( elem => elem.City === ele.City ));
    const ageArray = [];
    for (let i = 16; i <= 100; i++) {
      ageArray.push(i);
    }

    return (
      <div>
        {this.state.loading ? <Loader /> : null}

        <div className="main-container default-page pt-2 mt-2">
          {CONFIG.DATA.THEME === 2 ? (
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">Employment</h2>
                      <ol className="breadcrumb ml-5">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/employment">Employment</a>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          ) : (
            <div className="title-breadcrumb">
              <div className="container">
                <header className="entry-header">
                  <h1 className="entry-title">Employment</h1>
                </header>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span> Employment</span>
                </div>
              </div>
            </div>
          )}
          <div className="clearfix"></div>
          <div className="container">
            <div className="row">
              <div className="col-xs-12 ">
                <div className="page-content default-page">
                  <article
                    style={{ textAlign: "left" }}
                    id="post-8359"
                    className="pt-3 post-8359 page type-page status-publish hentry"
                  >
                    <div className="entry-content">
                      <div className="vc_row wpb_row vc_row-fluid">
                        <div className="row-container">
                          <div className="wpb_column vc_column_container vc_col-sm-12">
                            <div className="vc_column-inner">
                              {CONFIG.DATA.BACKEND_HOST === "mosersfoods" && (
                                <a
                                  href="https://pfsbrands.com/careers/"
                                  target="_blank"
                                >
                                  <button
                                    style={{
                                      cursor: "pointer",
                                      padding: "0.5rem",
                                      marginBottom: "1rem",
                                    }}
                                  >
                                    Click here for Deli/Bakery Positions!
                                  </button>
                                </a>
                              )}
                              <div className="wpb_wrapper">
                                {CONFIG.DATA.BACKEND_HOST ==
                                  "dicksfreshmarket" ? (
                                  <div className="wpb_text_column wpb_content_element ">
                                    <div className="wpb_wrapper">
                                      <p>
                                        At Dick’s Fresh Market we are always
                                        seeking Clean, Neat, Fresh & Friendly
                                        talent to grow with our expanding
                                        company.
                                      </p>
                                      <p>
                                        Our store locations in Osceola, Amery,
                                        River Falls, Menomonie, and Wabasha
                                        offer both part-time and full-time
                                        opportunities that support flexible
                                        scheduling.
                                      </p>
                                      <p>
                                        Our full-time team member benefits
                                        include health, dental, life and HSA
                                        insurance benefits with paid training
                                        and paid time off available.{" "}
                                      </p>
                                      <br />
                                      <p>
                                        Apply online for an essential and stable
                                        career opportunity with one of our
                                        amazing teams today!
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {CONFIG.DATA.BACKEND_HOST == "handyfoodsiga" ? (
                                  <div className="wpb_text_column wpb_content_element ">
                                    <div className="wpb_wrapper">
                                      <p>
                                        Applicants, please note this Handy Foods
                                        is located in Ottawa, Illinois.
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {CONFIG.DATA.BACKEND_HOST ==
                                  "cashsaverstore" ? (
                                  <div className="wpb_text_column wpb_content_element ">
                                    <div className="wpb_wrapper">
                                      <p>
                                        Applicants, please note this Cash Saver
                                        IGA is located in Lake Worth, Texas.
                                      </p>
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}

                                <div className="wpb_text_column wpb_content_element ">
                                  <div className="wpb_wrapper">
                                    <p>WE ARE A COMPLETE DRUG FREE WORKPLACE</p>
                                    {CONFIG.DATA.EMPLOYEMENT_TEXT_1 && (
                                      <p>{CONFIG.DATA.EMPLOYEMENT_TEXT_1}</p>
                                    )}
                                    <div>
                                      <ol>
                                        <li>
                                          We consider applicants for all
                                          positions without regard to race,
                                          color, religion, sex, national origin,
                                          age, marital or military status, the
                                          presence of a non-job-related medical
                                          condition or disability, or any other
                                          legally protected status. We comply
                                          with all applicable laws governing
                                          employment practices, and we do not
                                          discriminate on the basis of any
                                          unlawful criteria.
                                        </li>
                                        <li>
                                          This application will be considered
                                          current for only 30 days from the date
                                          of completion.
                                        </li>
                                        <li>
                                          All questions must be answered for the
                                          application to be considered. If not
                                          applicable, please indicate with N/A.
                                        </li>
                                      </ol>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className="wpforms-container wpforms-container-full"
                                  id="wpforms-8464"
                                >
                                  <form
                                    id="empForm"
                                    className="wpforms-validate wpforms-form"
                                    data-formid="8464"
                                    method="post"
                                    encType="multipart/form-data"
                                    action="/employment/"
                                    noValidate="novalidate"
                                  >
                                    <div className="wpforms-field-container">
                                      <div
                                        id="wpforms-8464-field_1-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-third wpforms-first"
                                        data-field-id="1"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_1"
                                        >
                                          Name
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="name"
                                          onChange={this.changeHandler}
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "name",
                                            this.state.formControls.name,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_2-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-third"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_2"
                                        >
                                          Phone
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <InputMask
                                          mask="(999) 999-9999"
                                          type="text"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="phone"
                                          required=""
                                          onChange={this.changeHandler}
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "phone",
                                            this.state.formControls.phone,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_3-container"
                                        className="wpforms-field wpforms-field-email wpforms-one-third"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_3"
                                        >
                                          Email
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="email"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="email"
                                          onChange={this.changeHandler}
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "email",
                                            this.state.formControls.email,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_6-container"
                                        className="wpforms-field wpforms-field-text"
                                        data-field-id="6"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_6"
                                        >
                                          Street Address
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          id="wpforms-8464-field_6"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="street_address"
                                          onChange={this.changeHandler}
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "Street Address",
                                            this.state.formControls
                                              .street_address,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_7-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth wpforms-first"
                                        data-field-id="7"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_7"
                                        >
                                          City
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          id="wpforms-8464-field_7"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="city"
                                          onChange={this.changeHandler}
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "City",
                                            this.state.formControls.city,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_8-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="8"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_8"
                                        >
                                          State / Province / Region
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_8"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="state"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "State",
                                            this.state.formControls.state,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_9-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="9"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_9"
                                        >
                                          Zip Code
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_9"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="zip_code"
                                          maxLength="6"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "Zip Code",
                                            this.state.formControls.zip_code,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_10-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="10"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_10"
                                        >
                                          Country{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_10"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="country"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "country",
                                            this.state.formControls.country,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_11-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth wpforms-first"
                                        data-field-id="11"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_11"
                                        >
                                          How long have you lived at this
                                          address?
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_11"
                                          className="-large wpforms-field-required"
                                          name="how_long_have_you_lived_at_this_address"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .how_long_have_you_lived_at_this_address,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_12-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="12"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_12"
                                        >
                                          Referred By
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_12"
                                          className="wpforms-field-large"
                                          name="referred_by"
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls.referred_by,
                                            "required"
                                          )}
                                        </div>
                                      </div>

                                      {/* <div
                                        id="wpforms-8464-field_10-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="10"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_10"
                                        >
                                          Age{" "}
                                          {CONFIG.DATA
                                            .ALLOW_EMPLOYMENT_PAGE_AGE_FILED_OPTION ? (
                                            ""
                                          ) : (
                                            <span className="wpforms-required-label">
                                              *
                                            </span>
                                          )}
                                        </label>
                                        <select
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_15"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="age"
                                          required=""
                                        >
                                          <option>Select Age</option>
                                          {ageArray.map((each) => (
                                            <option value={each}>{each}</option>
                                          ))}
                                        </select>
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "Age",
                                            this.state.formControls.age,
                                            CONFIG.DATA
                                              .ALLOW_EMPLOYMENT_PAGE_AGE_FILED_OPTION
                                              ? ""
                                              : "required"
                                          )}
                                        </div>
                                      </div> */}

                                      <div
                                        id="wpforms-8464-field_14-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="14"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_14"
                                        >
                                          Date you can start
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="date"
                                          id="wpforms-8464-field_14"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="date_you_can_start"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .date_you_can_start,
                                            "required"
                                          )}
                                        </div>
                                      </div>

                                      <div
                                        id="wpforms-8464-field_13-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="13"
                                      >
                                        {
                                          CONFIG.DATA.BACKEND_HOST ===
                                            "diamondfood" ||
                                            CONFIG.DATA.BACKEND_HOST ===
                                            "cashsaverstore" ||
                                            CONFIG.DATA.BACKEND_HOST ==
                                            "metrodiscount" ? (
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_13"
                                            >
                                              Position Apply For
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                          ) : (
                                            ""
                                          )
                                          // (
                                          //   <label
                                          //     className="wpforms-field-label"
                                          //     htmlFor="wpforms-8464-field_13"
                                          //   >
                                          //     Wage expected
                                          //     <span className="wpforms-required-label">
                                          //       *
                                          //     </span>
                                          //   </label>
                                          // )
                                        }

                                        {/* <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_13"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="wage_expected"
                                          required=""
                                        />
                                        <div className='text-danger text-left '>{this.validator.message(' ', this.state.formControls.wage_expected, 'required')}</div> */}
                                      </div>

                                      <div
                                        id="wpforms-8464-field_15-container"
                                        className="wpforms-field wpforms-field-text"
                                        data-field-id="15"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_15"
                                        >
                                          Do you now or have you ever had a
                                          relative (includes in-laws) that
                                          worked for{" "}
                                          {CONFIG.DATA.RSA_CLIENT_APP_NAME} ?
                                          (Yes or No)
                                          <br /> If yes, please list their
                                          name(s) and location(s)
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_15"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="do_you_now_or_have_you_ever_had_a_relative_includes_in_laws_that_worked_for_us"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .do_you_now_or_have_you_ever_had_a_relative_includes_in_laws_that_worked_for_us,
                                            "required"
                                          )}
                                        </div>
                                      </div>

                                      {CONFIG.DATA.BACKEND_HOST ==
                                        "themarketplace" ? (
                                        <div
                                          id="wpforms-8464-field_2020-container"
                                          className="wpforms-field wpforms-field-text wpforms-one-third wpforms-first"
                                          data-field-id="1620"
                                        >
                                          <label
                                            className="wpforms-field-label"
                                            htmlFor="wpforms-8464-field_2020"
                                          >
                                            Are you at least 18 years of age? If
                                            not, how old?
                                            <span className="wpforms-required-label">
                                              *
                                            </span>
                                          </label>

                                          <input
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="wpforms-8464-field_2020"
                                            className="wpforms-field-large wpforms-field-required"
                                            name="are_you_at_least_18_years_of_age_if_not_how_old"
                                            required=""
                                          />
                                          <div className="text-danger text-left ">
                                            {this.validator.message(
                                              " ",
                                              this.state.formControls
                                                .are_you_at_least_18_years_of_age_if_not_how_old,
                                              "required"
                                            )}
                                          </div>
                                        </div>
                                      ) : (
                                        <div
                                          id="wpforms-8464-field_16-container"
                                          className="wpforms-field wpforms-field-text wpforms-one-third wpforms-first"
                                          data-field-id="16"
                                        >
                                          <label
                                            className="wpforms-field-label"
                                            htmlFor="wpforms-8464-field_16"
                                          >
                                            Are you currently in High School
                                            (Yes or No)
                                            <span className="wpforms-required-label">
                                              *
                                            </span>
                                          </label>

                                          <select
                                            onChange={this.changeHandler}
                                            type="text"
                                            id="wpforms-8464-field_15"
                                            className="wpforms-field-large wpforms-field-required"
                                            name="are_you_currently_in_high_school"
                                            required=""
                                          >
                                            {" "}
                                            <option value="">Select</option>
                                            <option value="yes">Yes</option>
                                            <option value="no">No</option>
                                          </select>
                                          <div className="text-danger text-left ">
                                            {this.validator.message(
                                              " ",
                                              this.state.formControls
                                                .are_you_currently_in_high_school,
                                              "required"
                                            )}
                                          </div>
                                        </div>
                                      )}

                                      <div
                                        id="wpforms-8464-field_17-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-third"
                                        data-field-id="17"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_17"
                                        >
                                          College or University Credits (Yes or
                                          No){" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <select
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_15"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="college_or_university_credits"
                                          required=""
                                        >
                                          {" "}
                                          <option value="">Select</option>
                                          <option value="yes">Yes</option>
                                          <option value="no">No</option>
                                        </select>
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .college_or_university_credits,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_18-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-third"
                                        data-field-id="18"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_18"
                                        >
                                          Did you earn a degree(s)? (Yes or No){" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <select
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_15"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="did_you_earn_a_degree"
                                          required=""
                                        >
                                          <option value="">Select</option>
                                          <option value="yes">Yes</option>
                                          <option value="no">No</option>
                                        </select>
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .did_you_earn_a_degree,
                                            "required"
                                          )}
                                        </div>
                                      </div>

                                      <div
                                        id="wpforms-8464-field_20-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth wpforms-first"
                                        data-field-id="20"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_20"
                                        >
                                          Company Name{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_20"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="company_name1"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .company_name1,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_21-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="21"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_21"
                                        >
                                          Phone Number{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <InputMask
                                          mask="(999) 999-9999"
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_21"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="phone_number1"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .phone_number1,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_22-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-half"
                                        data-field-id="22"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_22"
                                        >
                                          Street Address{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_22"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="street_address1"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls
                                              .street_address1,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_23-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth wpforms-first"
                                        data-field-id="23"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_23"
                                        >
                                          City{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_23"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="city2"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls.city2,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_24-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="24"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_24"
                                        >
                                          State / Province / Region{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_24"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="state2"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls.state2,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_25-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="25"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_25"
                                        >
                                          Postal / Zip Code{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_25"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="postal"
                                          maxLength="6"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls.postal,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_26-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="26"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_26"
                                        >
                                          Country{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_26"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="country2"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls.country2,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_27-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth wpforms-first w--20"
                                        data-field-id="27"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_27"
                                        >
                                          Start Date
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>

                                        <input
                                          onChange={this.changeHandler}
                                          type="date"
                                          id="wpforms-8464-field_27"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="start_date"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls.start_date,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_28-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                        data-field-id="28"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_28"
                                        >
                                          End Date{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="date"
                                          id="wpforms-8464-field_28"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="end_date"
                                          required=""
                                        />
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            " ",
                                            this.state.formControls.end_date,
                                            "required"
                                          )}
                                        </div>
                                      </div>
                                      {/* {
                                        CONFIG.DATA.BACKEND_HOST !== "themarketplace"
                                          ?
                                          <div
                                            id="wpforms-8464-field_29-container"
                                            className="wpforms-field wpforms-field-text wpforms-one-fourth"
                                            data-field-id="29"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_29"
                                            >
                                              Salary{" "}
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <input
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_29"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="salary"
                                              required=""
                                            />
                                            <div className='text-danger text-left '>{this.validator.message(' ', this.state.formControls.salary, 'required')}</div>
                                          </div>
                                          : ''
                                      } */}
                                      <div>
                                        <div>
                                          <div
                                            id="wpforms-8464-field_30-container"
                                            className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                            data-field-id="30"
                                          >
                                            <label
                                              className="wpforms-field-label "
                                              htmlFor="wpforms-8464-field_30"
                                            >
                                              Reason for Leaving
                                            </label>
                                            <textarea
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_30"
                                              className="height-2"
                                              name="reason_for_leaving"
                                              style={{ height: 60 }}
                                              rows="4"
                                            />
                                          </div>
                                          <div
                                            id="wpforms-8464-field_31-container"
                                            className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                            data-field-id="31"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_31"
                                            >
                                              How many jobs have you had in the
                                              last 5 years not listed above{" "}
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <input
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_31"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="how_many_jobs_have_you_had_in_the_last_5_years_not_listed_above"
                                              required=""
                                            />
                                            <span className="text-danger">
                                              {this.validator.message(
                                                " ",
                                                this.state.formControls
                                                  .how_many_jobs_have_you_had_in_the_last_5_years_not_listed_above,
                                                "required"
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div className="secound">
                                          <div
                                            id="wpforms-8464-field_32-container"
                                            className="wpforms-field wpforms-field-text wpforms-one-half"
                                            data-field-id="32"
                                            style={{
                                              marginTop: "-100px",
                                              marginLeft: "3.7%",
                                            }}
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_32"
                                            >
                                              Please indicate the job duties you
                                              have performed which relate to the
                                              position for which you are
                                              applying
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <textarea
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_32"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="the_job_duties"
                                              required=""
                                              style={{ height: 117 }}
                                            />
                                            <span className="text-danger">
                                              {this.validator.message(
                                                "Job Duties",
                                                this.state.formControls
                                                  .the_job_duties,
                                                "required"
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                      </div>

                                      <div>
                                        <div>
                                          <div
                                            id="wpforms-8464-field_33-container"
                                            className="wpforms-field wpforms-field-text wpforms-one-third wpforms-first"
                                            data-field-id="33"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_33"
                                            >
                                              Are you eligible for employment in
                                              the United States? (Yes or No){" "}
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <select
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_15"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="are_you_eligible_for_employment_in_the_united_states"
                                              required=""
                                            >
                                              <option value="">Select</option>
                                              <option value="yes">Yes</option>
                                              <option value="no">No</option>
                                            </select>
                                            <div className="text-danger text-left ">
                                              {this.validator.message(
                                                " ",
                                                this.state.formControls
                                                  .are_you_eligible_for_employment_in_the_united_states,
                                                "required"
                                              )}
                                            </div>
                                          </div>
                                          <div
                                            id="wpforms-8464-field_35-container"
                                            className="wpforms-field wpforms-field-text wpforms-one-third wpforms-first"
                                            data-field-id="35"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_35"
                                            >
                                              Days Available for Work
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                              <samp>
                                                (Mon,Tue,Wed,Thu,Fri,Sat,Sun)
                                              </samp>
                                            </label>
                                            <input
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_35"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="days_available_for_work"
                                              required=""
                                            />
                                            <span className="text-danger">
                                              {this.validator.message(
                                                "Days Available",
                                                this.state.formControls
                                                  .days_available_for_work,
                                                "required"
                                              )}
                                            </span>
                                          </div>
                                          <div
                                            id="wpforms-8464-field_36-container"
                                            className="wpforms-field wpforms-field-text wpforms-one-third wpforms-first"
                                            data-field-id="36"
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_36"
                                            >
                                              Hours Available for Work{" "}
                                              <span className="wpforms-required-label">
                                                *
                                              </span>
                                            </label>
                                            <input
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_36"
                                              className="wpforms-field-large wpforms-field-required"
                                              name="hours_available_for_work"
                                              required=""
                                            />
                                            <span className="text-danger">
                                              {this.validator.message(
                                                "Hourls Available",
                                                this.state.formControls
                                                  .hours_available_for_work,
                                                "required"
                                              )}
                                            </span>
                                          </div>
                                        </div>
                                        <div>
                                          <div
                                            id="wpforms-8464-field_34-container"
                                            className="wpforms-field wpforms-field-text wpforms-two-thirds"
                                            data-field-id="34"
                                            style={{ marginTop: "-190px" }}
                                          >
                                            <label
                                              className="wpforms-field-label"
                                              htmlFor="wpforms-8464-field_34"
                                            >
                                              <br />
                                              Additional Notes
                                            </label>
                                            <textarea
                                              onChange={this.changeHandler}
                                              type="text"
                                              id="wpforms-8464-field_34"
                                              className="wpforms-field-large"
                                              name="additional_notes"
                                              style={{ height: 206 }}
                                              rows="4"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_37-container"
                                        className="wpforms-field wpforms-field-text"
                                        data-field-id="37"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_37"
                                        >
                                          The information above is true and
                                          correct. I understand the employers
                                          and persons listed in this application
                                          may also be contacted for verification
                                          and references. I authorize the
                                          verification of the information I have
                                          provided. I further understand that
                                          any falsification, misrepresentation
                                          or omissions may be grounds for
                                          termination of my employment with this
                                          company at any time. I understand the
                                          acceptance of this application and any
                                          other pre- employment processing by
                                          the company does not signify that a
                                          job opening exists and in no way is an
                                          offer of employment or a commitment of
                                          any kind by this company. (Yes or No)
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <select
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_15"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="The_information"
                                          required=""
                                        >
                                          <option value="">Select</option>
                                          <option value="yes">Yes</option>
                                          <option value="no">No</option>
                                        </select>
                                        <span className="text-danger">
                                          {this.validator.message(
                                            "Agreement",
                                            this.state.formControls
                                              .The_information,
                                            "required"
                                          )}
                                        </span>
                                      </div>
                                      <div
                                        id="wpforms-8464-field_38-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-third wpforms-first"
                                        data-field-id="38"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_38"
                                        >
                                          Name{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_38"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="name1"
                                          required=""
                                        />
                                        <span className="text-danger">
                                          {this.validator.message(
                                            "Name",
                                            this.state.formControls.name1,
                                            "required"
                                          )}
                                        </span>
                                      </div>

                                      <div
                                        id="wpforms-8464-field_39-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-third"
                                        data-field-id="39"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_39"
                                        >
                                          Store Location{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>

                                        <select
                                          onChange={this.changeHandler}
                                          type="text"
                                          id="wpforms-8464-field_15"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="store_location"
                                          required=""
                                        >
                                          <option>Select Location</option>
                                          {CONFIG.DATA.RSA_SUBDOMAIN ===
                                            "buchefoods" ? (
                                            <option key={1} value="anylocation">
                                              {"Any" + " " + "Location"}
                                            </option>
                                          ) : (
                                            ""
                                          )}

                                          {this.state.stores.length > 0 &&
                                            this.state.stores.map(
                                              (val, index) => {
                                                return CONFIG.DATA
                                                  .RSA_SUBDOMAIN ===
                                                  "tealsmarket" ? (
                                                  val.ClientStoreId !== 2 ? (
                                                    <option
                                                      key={index}
                                                      value={
                                                        val.ClientStoreName
                                                      }
                                                    >
                                                      {val.ClientStoreName}
                                                    </option>
                                                  ) : (
                                                    ""
                                                  )
                                                ) : CONFIG.DATA
                                                  .RSA_SUBDOMAIN ===
                                                  "buchefoods" ? (
                                                  <option
                                                    key={index}
                                                    value={val.ClientStoreName}
                                                  >
                                                    {val.ClientStoreName}
                                                  </option>
                                                ) : (
                                                  <option
                                                    key={index}
                                                    value={val.ClientStoreName}
                                                  >
                                                    {CONFIG.DATA
                                                      .RSA_SUBDOMAIN ===
                                                      "diamondfood"
                                                      ? val.ClientStoreName +
                                                      " - Lake Worth, TX"
                                                      : val.ClientStoreName}
                                                    { }
                                                  </option>
                                                );
                                              }
                                            )}
                                        </select>
                                        <span className="text-danger">
                                          {this.validator.message(
                                            "Location",
                                            this.state.formControls
                                              .store_location,
                                            "required"
                                          )}
                                        </span>
                                      </div>

                                      <div
                                        id="wpforms-8464-field_40-container"
                                        className="wpforms-field wpforms-field-text wpforms-one-third"
                                        data-field-id="40"
                                      >
                                        <label
                                          className="wpforms-field-label"
                                          htmlFor="wpforms-8464-field_40"
                                        >
                                          Date{" "}
                                          <span className="wpforms-required-label">
                                            *
                                          </span>
                                        </label>
                                        <input
                                          onChange={this.changeHandler}
                                          type="date"
                                          id="wpforms-8464-field_40"
                                          className="wpforms-field-large wpforms-field-required"
                                          name="date2"
                                          required=""
                                        />
                                        <span className="text-danger">
                                          {this.validator.message(
                                            "Date",
                                            this.state.formControls.date2,
                                            "required"
                                          )}
                                        </span>
                                      </div>
                                    </div>

                                    <div className="wpforms-submit-container">
                                      <div
                                        className="wpforms-submit-container mb-2 employmentcheckbox"
                                        style={{ color: "#999999" }}
                                      >
                                        <p>
                                          <input
                                            type="checkbox"
                                            onChange={this.changeHandler}
                                            value="1"
                                            name="terms"
                                            className="wpforms-field-medium "
                                          />{" "}
                                          I agree to the{" "}
                                          {CONFIG.DATA.RSA_CLIENT_APP_NAME}{" "}
                                          <Link to="/company-policies">
                                            Terms and Conditions
                                          </Link>
                                        </p>
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "Terms and Conditions ",
                                            this.state.formControls.terms,
                                            "required"
                                          )}
                                        </div>
                                      </div>

                                      <div className="ReCAPTCHA">
                                        <div className="text-danger text-left ">
                                          {this.validator.message(
                                            "captcha",
                                            this.state.formControls.Captcha,
                                            "required"
                                          )}
                                        </div>

                                        <ReCAPTCHA
                                          style={{ display: "inline-block" }}
                                          theme="light"
                                          sitekey="6LebzrYUAAAAAIo_0vP7bjbtzzBTKNlC4UvyEGKU"
                                          onChange={this.handleChange}
                                          asyncScriptOnLoad={
                                            this.asyncScriptOnLoad
                                          }
                                        />

                                        <br />
                                      </div>

                                      <button
                                        type="submit"
                                        name="wpforms[submit]"
                                        className="wpforms-submit "
                                        id="wpforms-submit-8464"
                                        value="wpforms-submit"
                                        aria-live="assertive"
                                        data-alt-text="Sending..."
                                        data-submit-text="Submit"
                                        onClick={(e) => this.Employment(e)}
                                        style={{
                                          padding: "1em 2em",
                                          borderRadius: "5px",
                                          boxShadow:
                                            "1px 1px 3px rgba(0,0,0,0.15)",
                                        }}
                                      >
                                        Submit
                                      </button>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </article>
                  <div id="comments" className="comments-area"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Employment;
